import React from 'react';

interface Artifact {
  id: number;
  artifact_type: string;
  data: any;
  title: string;
  description: string;
  created_at: string;
}

interface Message {
  id: number;
  text: string;
  sender: string;
  chat_thread_id: number;
  created_at: string;
  artifacts: Artifact[];
}

interface ChatBubbleProps {
  message: Message;
  isLast?: boolean;
  onArtifactSelect: (artifact: Artifact) => void;
}

const ChatBubble: React.FC<ChatBubbleProps> = ({ message, isLast, onArtifactSelect }) => {
  const isBot = message.sender === 'bot';

  return (
    <div className={`flex ${isBot ? 'justify-start' : 'justify-end'} mb-4`}>
      <div
        className={`max-w-[80%] ${
          isBot ? 'bg-white dark:bg-gray-700' : 'bg-blue-600 text-white'
        } rounded-lg px-4 py-2 text-sm shadow-sm`}
      >
        <div className="whitespace-pre-wrap">
          {message.text}
          <span className="text-xs opacity-75 dark:opacity-60 block mt-1">
            {new Date(message.created_at).toLocaleTimeString()}
          </span>
        </div>

        {message.artifacts && message.artifacts.length > 0 && (
          <div className="mt-2 border-t border-gray-200 dark:border-gray-600 pt-2">
            <div className="text-xs font-medium mb-1">Artifacts:</div>
            <div className="flex flex-wrap gap-2">
              {message.artifacts.map((artifact) => (
                <button
                  key={artifact.id}
                  onClick={() => onArtifactSelect(artifact)}
                  className={`px-2 py-1 rounded text-xs ${
                    isBot
                      ? 'bg-gray-200 dark:bg-gray-600 text-gray-700 dark:text-gray-200'
                      : 'bg-blue-700 text-white'
                  } transition-colors hover:opacity-80`}
                >
                  {artifact.title || artifact.artifact_type}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatBubble;
